import { JSEncrypt } from "jsencrypt";

const win: any = window

export function encrypt(message: any) {
  const publicKey = win.PK;
  const RSAEncrypt = new JSEncrypt();
  RSAEncrypt.setPublicKey(publicKey);
  const encryptedMessage = RSAEncrypt.encrypt(message);

  return encryptedMessage;
}

const createTransactionID = (isCorrelationId = false) => {
  const currentDateTime = new Date()
    .toISOString()
    .replace(/-|:|T/gi, '')
    .replace('.', '')
    .slice(2)
    .slice(0, -1)
  return (
    'POR' + (isCorrelationId ? 'C' : '') + currentDateTime + '_' + Math.ceil(Math.random() * 100000)
  )
}

const changeDateFormat = (str: any) => {
  if(str.length > 0) {    
    const today = new Date(str);
  
    let day: any = today.getDate();
    let month: any = today.getMonth() + 1;
    let year = today.getFullYear();
  
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
  
    const formattedDate = `${day}-${month}-${year}`;
  
    return formattedDate
  } else {
    return ''
  }
}
const setCookie = (name: string, value: string, days: number = 365) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};
const getCookie = (name: string) => {
    const cookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${name}=`));

    return cookie ? decodeURIComponent(cookie.split("=")[1]) : "";
};

export { createTransactionID, changeDateFormat, setCookie, getCookie };